import { BgPlaceholder, PlaceholderType } from '~/components/ui/BgPlaceholder';
import { rage } from '~/rage';

const Background = () =>
	rage.config.isStub() && (
		<BgPlaceholder $type={PlaceholderType.HobbyFishing} />
	);
export { Background };
